import { CityState, DataSource, Label, Layout, Location, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutDriverEvent extends Layout {
    EventToSeparator: Label;
    NotificationToSeparator: Label;
    citystateCityAutoHome: CityState;
    citystateEventLocation: CityState;
    labelLocationAutoHome: Location;
    locationEventLocation: Location;
    panelCreateAutoHome: Panel;
    panelCreateAutoHomeFields: Panel;
    panelDates: Panel;
    panelDriverEventLocation: Panel;
    panelLocation: Panel;
    panelStatusPriorityManagerRequest: Panel;
    sourceAutoHomeLocation: DataSource;
    sourceDriverEvents: DataSource;
    switchCreateAutoHome: Switch;
    switchLocationType: Switch;
    textboxAddress: Textbox;
    textboxDriverEvent: Textbox;
    textboxDriverManager: Textbox;
    textboxEnteredBy: Textbox;
    textboxEntryDate: Textbox;
    textboxEquipmentId: Textbox;
    textboxEventFromDate: Textbox;
    textboxEventStatus: Textbox;
    textboxEventToDate: Textbox;
    textboxLatitude: Textbox;
    textboxLongitude: Textbox;
    textboxNotifyEndDate: Textbox;
    textboxNotifyStartDate: Textbox;
    textboxPriority: Textbox;
    textboxRemark: Textbox;
    textboxRequestDate: Textbox;
    textboxTypeOf: Textbox;
}
